import React, { Component } from "react"
import PhoneInput from "react-phone-input-2"
import { navigate } from "gatsby"
import omit from "lodash.omit"
import Cookies from 'js-cookie'

import "react-phone-input-2/lib/style.css"
import Styles from "./registration-form.module.scss"

class RegistrationForm extends Component {
  constructor(props) {
    super(props)
    this.ContactForm = React.createRef()

    let campaignURL = Cookies.get('__gtm_campaign_url')
    let email = Cookies.get('email')
    let team_name = Cookies.get('team_name')
    this.state = {campaignURL: campaignURL, email: email, team_name: team_name}
  }

  encode = data => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = this.ContactForm.current
    const fieldsToSubmit = omit(this.state, "selectedOption")
    const { email } = this.state

    if (window.trackRoarEvent) {
      window.trackRoarEvent(email)
    }

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: this.encode({
        "form-name": form.getAttribute("name"),
        ...fieldsToSubmit,
      }),
    })
      .then(response => {
        navigate(form.getAttribute("action"))
      })
      .catch(error => {
        console.log(`error in submiting the form data:${error}`)
      })
  }
  render() {
    const { name, phone, email, company } = this.state
    let canSubmit = (name && phone && email && company) || false

    return (
      <form
        className={Styles.form}
        name={this.props.formName}
        method="post"
        action="/contact-confirmation"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={this.handleSubmit}
        ref={this.ContactForm}
      >
        <input type="hidden" name="form-name" value="contact" />
        <div hidden>
          <label htmlFor={"bot-field"}>
            Don’t fill this out:{" "}
            <input
              name="bot-field"
              onChange={this.handleChange}
              className={Styles.input}
            />
          </label>
        </div>
        <div hidden>
          <input
            name="campaignURL"
            onChange={this.handleChange}
            value={this.state.campaignURL}
          />
        </div>
        <div className={Styles.inputRow}>
          <label htmlFor={"name"}>
            Full name*
            <br />
            <input
              placeholder={"Please enter your full name"}
              required={true}
              type="text"
              name="name"
              onChange={this.handleChange}
              className={Styles.input}
            />
          </label>
        </div>
        <div className={Styles.inputRow}>
          <label htmlFor={"email"}>
            Work email address*
            <br />
            <input
              placeholder={"Please enter your email address"}
              required={true}
              type="email"
              name="email"
              value={this.state.email}
              onChange={this.handleChange}
              className={Styles.input}
            />
          </label>
        </div>
        <div className={Styles.inputRow}>
          <label htmlFor={"company"}>
            Opportunity company name*
            <br />
            <input
              required
              placeholder={"Please enter your company name"}
              type="text"
              name="company"
              value={this.state.team_name}
              onChange={this.handleChange}
              className={Styles.input}
            />
          </label>
        </div>
        <div className={Styles.inputRow}>
          <label htmlFor={"phone"}>
            Your contact number*
            <br />
          </label>
          <PhoneInput
            containerClass={`react-tel-input ${Styles.phoneContainer}`}
            inputClass={Styles.phoneInput}
            country={"gb"}
            value={this.state.phone}
            onChange={phone => this.setState({ phone })}
            inputProps={{ name: "phone" }}
          />
        </div>

        <div className={Styles.inputRow}>
          <label htmlFor={"message"}>
            Message
            <br />
          </label>
          <textarea
            placeholder={"Please enter a message"}
            required={true}
            type="text"
            name="message"
            onChange={this.handleChange}
            className={Styles.textarea}
          />
        </div>

        <p>
          <button
            className={Styles.inputSubmit}
            disabled={!canSubmit}
            type="submit"
          >
            Submit
          </button>
        </p>
      </form>
    )
  }
}
export default RegistrationForm
